import { FETCH_SEARCH, CLEAR_SEARCH } from '../actions/types';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_SEARCH:
      return { ...state, data: action.payload.data };
    case CLEAR_SEARCH:
      return { ...state, data: [] };
    default:
      return state;
  }
};
